// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"081e8a62","124":"62508393","218":"938930cb","415":"78010bf8","538":"aeed7b96","624":"b6ed0b22","745":"3c87de14","927":"b6ed0b22"}[chunkId] + ".chunk.css";
};